import React, { FC } from 'react';
import styled from 'styled-components';
import { Container } from '../atoms/container';
import { Bio } from '../molecules/bio';
import { LegalDisclaimer } from '../molecules/legal-disclaimer';

const FooterContainer = styled.div`
  background-color: white;
  padding-bottom: ${({ theme }): string => theme.mixins.spacing(2)};
`;

export const Footer: FC = () => (
  <FooterContainer>
    <Container>
      <Bio />
      <LegalDisclaimer />
    </Container>
  </FooterContainer>
);
